/* Core & libraries */
import React from "react";

/* Helpers, constants, custom methods, internal libraries */
import { AIRLINES } from "../../constants/appConstants";
import { getLazyComponentWithSuspense, lazyWithPreload } from "../../helpers/lazyLoadingHelpers";

/* Components */
export const SafetyAA = lazyWithPreload(() => import('../../components/safetyPageByProvider/AA'));
export const SafetyAS = lazyWithPreload(() => import('../../components/safetyPageByProvider/AS'));
export const SafetyAM = lazyWithPreload(() => import('../../components/safetyPageByProvider/AM'));
export const SafetyAC = lazyWithPreload(() => import('../../components/safetyPageByProvider/AC'));
export const SafetyCHOICE = lazyWithPreload(() => import('../../components/safetyPageByProvider/CHOICE'));

/* Styles */
import {useUserContext} from "../../contexts/userContext";

const SAFETY_PAGE_BY_AIRLINE = {
  [AIRLINES.AA]: getLazyComponentWithSuspense(SafetyAA),
  [AIRLINES.AS]: getLazyComponentWithSuspense(SafetyAS),
  [AIRLINES.CHOICE]: getLazyComponentWithSuspense(SafetyCHOICE),
  [AIRLINES.AM]: getLazyComponentWithSuspense(SafetyAM),
  [AIRLINES.AC]: getLazyComponentWithSuspense(SafetyAC),
};

const Safety = () => {
  const userDetails = useUserContext();
  const airline = userDetails?.userInfo?.providerInfo?.providerCode;

  const SafetyPageComponent = SAFETY_PAGE_BY_AIRLINE[airline];

  return SafetyPageComponent ? SafetyPageComponent : null;
};

export default Safety;
